module.exports = __webpack_public_path__ + "static/media/stretcher.71b3d013.svg";